import { styled } from '@mui/material/styles'
import { GlassOutlineButton } from './Glass'

// Navigation is a quiet pill, not a raised primary action.
const PollNavButton = styled(GlassOutlineButton)({
  // Override shared navigation sizing regardless of style insertion order.
  '&&&': {
    height: 32,
    minHeight: 32,
    minWidth: 0,
    padding: '3px 12px',
    borderRadius: '999px',
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.5,
    color: '#855c3d',
    background: '#fffaf5',
    border: '1px solid #ead3bb',
    boxShadow: 'none',
    '&.Mui-focusVisible': { outline: '3px solid #e98549', outlineOffset: 3 },
    '&:hover, &:active': {
      background: '#fffaf5',
      borderColor: '#ead3bb',
      boxShadow: 'none',
      transform: 'none',
    },
    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': { background: '#fff0df', borderColor: '#d4a27a' },
    },
    '&.Mui-disabled': {
      color: '#b19378',
      background: '#fff4e8',
      borderColor: '#efddc9',
      boxShadow: 'none',
    },
  },
})

export default PollNavButton
